import { hasText } from 'shared/lib/common-util'
import { RuleResult } from '../../../../types/DeclarationP5'

const C0944Validator = {
  validateConsignmentTransportChargesRequirement: ({
    security,
    additionalDeclarationType,
  }: {
    security: string
    additionalDeclarationType: string
  }): RuleResult => {
    if (security === '0') return 'NOT_ALLOWED'
    if (['1', '3'].includes(security)) {
      return additionalDeclarationType === 'D' ? 'OPTIONAL' : 'REQUIRED'
    }

    return 'OPTIONAL'
  },
  validateHouseConsignmentTransportChargesRequirement: ({
    security,
    additionalDeclarationType,
    transportChargesMethodOfPayment,
  }: {
    security: string
    additionalDeclarationType: string
    transportChargesMethodOfPayment: string
  }): RuleResult => {
    if (security === '0') return 'NOT_ALLOWED'
    if (['1', '3'].includes(security)) {
      return additionalDeclarationType === 'D' ? 'OPTIONAL' : 'REQUIRED'
    }

    return hasText(transportChargesMethodOfPayment) ? 'NOT_ALLOWED' : 'OPTIONAL'
  },
}

export default C0944Validator
